import { render, staticRenderFns } from "./houseProperty.vue?vue&type=template&id=2b7002a2&scoped=true&"
import script from "./houseProperty.vue?vue&type=script&lang=js&"
export * from "./houseProperty.vue?vue&type=script&lang=js&"
import style0 from "./houseProperty.vue?vue&type=style&index=0&id=2b7002a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7002a2",
  null
  
)

export default component.exports